/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, debounce, Switch, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomInput from "../../components/inputs/customInput";
import AddIcon from '@mui/icons-material/Add';
import Popup from "../../components/popups/popup";
import { useTheme } from "@emotion/react";
import PostService from "../../services/postService";
import PostTypeDropdown from "../../components/dropdowns/postTypeDropdown";
import CityDropdown from "../../components/dropdowns/cityDropdown";
import StreetDropdown from "../../components/dropdowns/streetDropdown";
import DriverDropdown from "../../components/dropdowns/driverDropdown";
import PostStatusDropdown from "../../components/dropdowns/postRelated/postStatusDropdown";
import TypeDropdown from "../../components/dropdowns/postRelated/typePostDropdown";
import ChangeStatusDropdown from "../../components/dropdowns/postRelated/changeStatusDropdown";
import CityPriceService from "../../services/cityPriceService";
import BlockedNumberService from "../../services/blockedNumberService";
import RefCustomInput from "../../components/inputs/refCustomInput";
import usePdfPost from "../../components/prints/pdfOnePost";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PageDropdown from "../../components/dropdowns/pageDropdown";

const AddPost = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const [selectedPage, setSelectedPage] = useState(null);
    const [selectedPostType, setSelectedPostType] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedStreet, setSelectedStreet] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedPostStatus, setSelectedPostStatus] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [selectedChangeStatus, setSelectedChangeStatus] = useState(null);
    const [cityPrices, setCityPrices] = useState([]);
    const [blockedNumber, setBlockedNumber] = useState(false);
    const [blockedNumber2, setBlockedNumber2] = useState(false);
    const [pageCheck, setPageCheck] = useState(false);
    const [initialPostStatus, setInitialPostStatus] = useState(null);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);

    const [showAllDrivers, setShowAllDrivers] = useState(false);
    const [pdf, setPdf] = useState(false);
    const [pdfPostId, setPdfPostId] = useState(null);
    const [print, setPrint] = useState(false);
    const { isLoading: isPDF, pdfPost } = usePdfPost();

    const [formValues, setFormValues] = useState({
        receiverName: '',
        receiverAddress: '',
        receiverPhone: '',
        receiverPhoneTwo: '',
        invoiceNumber: '',
        totalPrice: '',
        transportationPrice: 0,
        driverPrice: 0,
        note: '',
        pageId: null,
        postTypeId: null,
        driverId: null,
        streetId: null,
        postStatusId: null,
        type: null,
        changeStatus: null,
    });

    const [addErrors, setAddErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
        if (name === 'receiverPhone' || name === 'receiverPhoneTwo') {
            debouncedFetchData(value, name);
        }
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;

        const numericValue = value === '-' ? '-' : value.replace(/,/g, '');

        if (!isNaN(numericValue) || numericValue === '-') {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: numericValue,
            }));
        }
    };


    const debouncedFetchData = useMemo(() =>
        debounce((phone, type) => {
            fetchCheckPhone(phone, type);
        }, 1000), []
    );

    const validateForm = () => {
        const newAddErrors = {};

        if (!formValues.receiverPhone) {
            newAddErrors.receiverPhone = t('receiverPhoneRequired');
        }

        else if (!/^(\d{11}|\+964\d{10})$/.test(formValues.receiverPhone)) {
            newAddErrors.receiverPhone = t('receiverPhoneInvalid');
        }

        if (!formValues.totalPrice) {
            newAddErrors.totalPrice = t('totalPriceRequired');
        }

        if (isNaN(formValues.totalPrice)) {
            newAddErrors.totalPrice = t('totalPriceNumber');
        }

        if (isNaN(formValues.driverPrice)) {
            newAddErrors.driverPrice = t('driverPriceNumber');
        }

        if (isNaN(formValues.transportationPrice)) {
            newAddErrors.transportationPrice = t('transportationPriceNumber');
        }

        if (!formValues.pageId) {
            newAddErrors.page = t('pageRequired');
        }

        if (!formValues.cityId) {
            newAddErrors.city = t('cityRequired');
        }

        if (!formValues.postTypeId) {
            newAddErrors.postType = t('postTypeRequired');
        }

        if (!formValues.driverId) {
            newAddErrors.driver = t('driverRequired');
        }

        if (!formValues.streetId) {
            newAddErrors.street = t('streetRequired');
        }

        if (!formValues.postStatusId) {
            newAddErrors.postStatus = t('postStatusRequired');
        }

        if (!formValues.type) {
            newAddErrors.type = t('typeRequired');
        }

        if (!formValues.changeStatus && formValues.type === 'change') {
            newAddErrors.changeStatus = t('changeStatusRequired');
        }

        setAddErrors(newAddErrors);

        return Object.keys(newAddErrors).length === 0;
    };

    const handleClearForm = () => {
        setFormValues({
            receiverName: '',
            receiverAddress: '',
            receiverPhone: '',
            receiverPhoneTwo: '',
            invoiceNumber: '',
            totalPrice: '',
            transportationPrice: 0,
            driverPrice: 0,
            note: '',
            type: "new",
            changeStatus: "inOffice",
            postStatusId: initialPostStatus ? initialPostStatus.id : null,
        });
        setSelectedPage(null);
        setSelectedPostType(null);
        setSelectedCity(null);
        setSelectedStreet(null);
        setSelectedDriver(null);
        setSelectedPostStatus(initialPostStatus);
        setBlockedNumber(false);
        setBlockedNumber2(false);
        setPageCheck(false);
        setSelectedType(t("new"));
        setSelectedChangeStatus(t("inOffice"));

        setAddErrors({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);

                let payload = {};
                if (formValues.type === 'change') {
                    const { cityId, ...otherData } = formValues;
                    payload = otherData;
                } else {
                    const { cityId, changeStatus, ...otherData } = formValues;
                    payload = otherData;
                }

                const data = await PostService.add(payload);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    handleClearForm();
                }
                setAddErrors({});
                if (pdf) {
                    setPdfPostId(data.data.id);
                } else if (print) {
                    handlePrint(data.data.id);
                }
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setAddErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setAddErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (pdfPostId) {
            pdfPost(pdfPostId);
            setPdfPostId(null);
        }
    }, [pdfPostId]);


    const fetchCityPrices = async () => {
        try {
            const data = await CityPriceService.fetchByUser();
            setCityPrices(data);

        } catch (error) {
            console.error('Error fetching city prices:', error);
        }
    };

    const fetchCheckPhone = async (phone, type) => {
        try {
            if (type === 'receiverPhone') setBlockedNumber(false);
            else setBlockedNumber2(false);

            const data = await BlockedNumberService.checkPhone(phone);

            if (data.isExist) {
                if (type === 'receiverPhone') setBlockedNumber(true);
                else setBlockedNumber2(true);
            }
        } catch (error) {
            console.error('Error fetching blocked number:', error);
        }
    };

    const fetchCheckPageAndPhone = async (pageId, phone) => {
        try {
            if (pageId && phone) {
                const data = await PostService.checkByPageAndPhone(pageId, phone);
                setPageCheck(data.isExist);
            }
        } catch (error) {
            console.error('Error fetching check post:', error);
        }
    };

    const updateTransportationPrice = (cityId) => {
        if (selectedPage && (selectedCity || selectedStreet)) {
            const checkPrice = selectedPage.cityPages.find((obj) => obj.cityId === cityId);

            if (checkPrice) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    transportationPrice: checkPrice.transportationPrice,
                }));
            } else {
                const checkCity = cityPrices.find((obj) => obj.cityId === cityId);

                setFormValues((prevValues) => ({
                    ...prevValues,
                    transportationPrice: checkCity ? checkCity.transportationPrice : 0,
                }));
            }
        }
        else if (cityPrices.length !== 0) {
            const checkPrice = cityPrices.find((obj) => obj.cityId === cityId);

            setFormValues((prevValues) => ({
                ...prevValues,
                transportationPrice: checkPrice ? checkPrice.transportationPrice : 0,
            }));

        }
    };

    const updateDriverPrice = () => {
        if (selectedDriver && selectedStreet) {
            const checkPrice = selectedDriver.streetDrivers.find((obj) => obj.streetId === selectedStreet.id);

            if (checkPrice) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    driverPrice: checkPrice.transportationPrice,
                }));
            } else {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    driverPrice: selectedDriver ? (selectedDriver.transportationPrice || 0) : 0,
                }));
            }
        }
        else if (selectedDriver) {
            setFormValues((prevValues) => ({
                ...prevValues,
                driverPrice: selectedDriver ? (selectedDriver.transportationPrice || 0) : 0,
            }));
        }
    };


    useEffect(() => {
        fetchCityPrices();
    }, []);

    useEffect(() => {
        setShowAllDrivers(false);
        updateTransportationPrice(selectedCity ? selectedCity.id : null);
    }, [selectedCity]);

    useEffect(() => {
        updateTransportationPrice(selectedStreet ? selectedStreet.city.id : null);
    }, [selectedStreet]);

    useEffect(() => {
        updateTransportationPrice(selectedStreet ? selectedStreet.city.id : (selectedCity ? selectedCity.id : null));
        if (formValues.receiverPhone)
            fetchCheckPageAndPhone(selectedPage && selectedPage.id, formValues.receiverPhone);

    }, [selectedPage]);

    useEffect(() => {
        if (formValues.receiverPhone && selectedPage)
            fetchCheckPageAndPhone(selectedPage && selectedPage.id, formValues.receiverPhone);
    }, [formValues.receiverPhone]);

    useEffect(() => {
        updateDriverPrice();
    }, [selectedDriver, selectedStreet]);

    const inputRefs = useRef([]);

    const handleKeyDown = (event, row, col) => {
        console.log(`Key pressed: ${event.key}, Position: Row ${row}, Column ${col}`);

        switch (event.key) {
            case "ArrowRight": // Move to next column
                if (inputRefs.current[row] && inputRefs.current[row][col + 1]) {
                    inputRefs.current[row][col + 1].focus();
                }
                break;

            case "ArrowLeft": // Move to previous column
                if (inputRefs.current[row] && inputRefs.current[row][col - 1]) {
                    inputRefs.current[row][col - 1].focus();
                }
                break;

            case "ArrowDown": // Move to next row (same column)
                if (inputRefs.current[row + 1] && inputRefs.current[row + 1][col]) {
                    inputRefs.current[row + 1][col].focus();
                }
                break;

            case "ArrowUp": // Move to previous row (same column)
                if (inputRefs.current[row - 1] && inputRefs.current[row - 1][col]) {
                    inputRefs.current[row - 1][col].focus();
                }
                break;

            default:
                break;
        }
    };

    const handlePrint = async (id) => {
        try {
            console.log("printing post " + id);
            const response = await PostService.sendPostToPrint(id);
            console.log(response);
        } catch (error) {
            console.error('Error sending post:', error);
        } finally {
            setPrint(false);
        }
    };


    return (
        <Box sx={{
            p: isTablet ? 0.6 : 2,
            backgroundColor: theme.palette.secondary.main,
        }}>

            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    width: '100%',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: 1,
                    borderColor: theme.palette.customGrey.borderInput,
                    px: isTablet ? 1 : 4,
                    py: 1
                }}
            >

                {/* row 1 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <PageDropdown
                            helperText={addErrors.page}
                            error={!!addErrors.page}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    </Box>


                    <Box width={isTablet ? '100%' : '32%'}>
                        <RefCustomInput
                            label={t('receiverName')}
                            placeholder={t('receiverNameHere')}
                            name="receiverName"
                            type='text'
                            value={formValues.receiverName}
                            error={!!addErrors.receiverName}
                            helperText={addErrors.receiverName}
                            onChange={handleChange}
                            ref={(el) => (inputRefs.current[0] ??= [], inputRefs.current[0][1] = el)}
                            onKeyDown={(e) => handleKeyDown(e, 0, 1)}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <RefCustomInput
                            label={t('receiverAddress')}
                            placeholder={t('receiverAddressHere')}
                            name="receiverAddress"
                            type='text'
                            value={formValues.receiverAddress}
                            error={!!addErrors.receiverAddress}
                            helperText={addErrors.receiverAddress}
                            onChange={handleChange}
                            ref={(el) => (inputRefs.current[0] ??= [], inputRefs.current[0][2] = el)}
                            onKeyDown={(e) => handleKeyDown(e, 0, 2)}
                        />
                    </Box>
                </Box>

                {/* row 2 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <RefCustomInput
                            label={t('receiverPhone')}
                            placeholder={t('receiverPhoneHere')}
                            name="receiverPhone"
                            type='text'
                            value={formValues.receiverPhone}
                            error={!!addErrors.receiverPhone}
                            helperText={addErrors.receiverPhone}
                            onChange={handleChange}
                            ref={(el) => (inputRefs.current[1] ??= [], inputRefs.current[1][0] = el)}
                            onKeyDown={(e) => handleKeyDown(e, 1, 0)}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <RefCustomInput
                            label={t('receiverPhoneTwo')}
                            placeholder={t('receiverPhoneTwoHere')}
                            name="receiverPhoneTwo"
                            type='text'
                            value={formValues.receiverPhoneTwo}
                            error={!!addErrors.receiverPhoneTwo}
                            helperText={addErrors.receiverPhoneTwo}
                            onChange={handleChange}
                            ref={(el) => (inputRefs.current[1] ??= [], inputRefs.current[1][1] = el)}
                            onKeyDown={(e) => handleKeyDown(e, 1, 1)}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <RefCustomInput
                            label={t('invoiceNumber')}
                            placeholder={t('invoiceNumberHere')}
                            name="invoiceNumber"
                            type='text'
                            value={formValues.invoiceNumber}
                            error={!!addErrors.invoiceNumber}
                            helperText={addErrors.invoiceNumber}
                            onChange={handleChange}
                            ref={(el) => (inputRefs.current[1] ??= [], inputRefs.current[1][2] = el)}
                            onKeyDown={(e) => handleKeyDown(e, 1, 2)}
                        />
                    </Box>
                </Box>

                {/* row 3 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <CityDropdown
                            helperText={addErrors.city}
                            error={!!addErrors.city}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedCity={selectedCity}
                            setSelectedCity={setSelectedCity}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <StreetDropdown
                            helperText={addErrors.street}
                            error={!!addErrors.street}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedStreet={selectedStreet}
                            setSelectedStreet={setSelectedStreet}
                            cityId={selectedCity && selectedCity.id}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'} sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'space-between'
                    }}>
                        <Box width={'85%'}>
                            <DriverDropdown
                                helperText={addErrors.driver}
                                error={!!addErrors.driver}
                                setFormValues={setFormValues}
                                isFilter={false}
                                selectedDriver={selectedDriver}
                                setSelectedDriver={setSelectedDriver}
                                cityId={(selectedCity && !showAllDrivers) && selectedCity.id}
                                withPrices={true}
                            />
                        </Box>
                        <Box>
                            <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 12,
                                }}
                            >
                                {t("showAllDrivers")}
                            </p>
                            <Switch
                                checked={showAllDrivers}
                                onClick={() => setShowAllDrivers((prev) => !prev)}
                            />
                        </Box>
                    </Box>
                </Box>

                {/* row 4 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <CustomInput
                            label={t('totalPrice')}
                            placeholder={t('totalPriceHere')}
                            name="totalPrice"
                            type='text'
                            value={
                                formValues.totalPrice !== '' && !isNaN(formValues.totalPrice)
                                    ? Number(formValues.totalPrice).toLocaleString()
                                    : formValues.totalPrice
                            }
                            error={!!addErrors.totalPrice}
                            helperText={addErrors.totalPrice}
                            onChange={handleNumberChange}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <CustomInput
                            label={t('transportationPrice')}
                            placeholder={t('transportationPriceHere')}
                            name="transportationPrice"
                            type='text'
                            value={formValues.transportationPrice ? Number(formValues.transportationPrice).toLocaleString() : 0}
                            error={!!addErrors.transportationPrice}
                            helperText={addErrors.transportationPrice}
                            onChange={handleNumberChange}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <CustomInput
                            label={t('driverPrice')}
                            placeholder={t('driverPriceHere')}
                            name="driverPrice"
                            type='text'
                            value={formValues.driverPrice ? Number(formValues.driverPrice).toLocaleString() : 0}
                            error={!!addErrors.driverPrice}
                            helperText={addErrors.driverPrice}
                            onChange={handleNumberChange}
                        />
                    </Box>
                </Box>

                {/* row 5 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '32%'}>
                        <PostTypeDropdown
                            helperText={addErrors.postType}
                            error={!!addErrors.postType}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedPostType={selectedPostType}
                            setSelectedPostType={setSelectedPostType}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <PostStatusDropdown
                            helperText={addErrors.postStatus}
                            error={!!addErrors.postStatus}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedPostStatus={selectedPostStatus}
                            setSelectedPostStatus={setSelectedPostStatus}
                            setInitialPostStatus={setInitialPostStatus}
                        />
                    </Box>

                    <Box width={isTablet ? '100%' : '32%'}>
                        <TypeDropdown
                            helperText={addErrors.type}
                            error={!!addErrors.type}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedType={selectedType}
                            setSelectedType={setSelectedType}
                        />
                    </Box>

                </Box>

                {/* row 6 */}
                <Box sx={{
                    display: isTablet ? 'unset' : 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box width={isTablet ? '100%' : '66%'}>
                        <CustomInput
                            label={t('note')}
                            placeholder={t('noteHere')}
                            name="note"
                            type='text'
                            value={formValues.note}
                            onChange={handleChange}
                        />
                    </Box>

                    {selectedType === t('change') && <Box width={isTablet ? '100%' : '32%'}>
                        <ChangeStatusDropdown
                            helperText={addErrors.changeStatus}
                            error={!!addErrors.changeStatus}
                            setFormValues={setFormValues}
                            isFilter={false}
                            selectedChangeStatus={selectedChangeStatus}
                            setSelectedChangeStatus={setSelectedChangeStatus}
                        />
                    </Box>}
                </Box>

                {(blockedNumber || blockedNumber2) && (
                    <Typography align="center" color='warning' variant="body2" sx={{ mt: 2 }}>
                        {t('blockedNumberExistsWarning')}
                    </Typography>
                )}

                {pageCheck && (
                    <Typography align="center" color={theme.palette.primary.main} variant="body2" sx={{ mt: 2 }}>
                        {t('todayPageExistsWarning')}
                    </Typography>
                )}

                {addErrors.general && (
                    <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                        {addErrors.general}
                    </Typography>
                )}

                <Box sx={{
                    display: 'flex',
                    flexDirection: isTablet ? 'column' : 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    mt: addErrors.general ? (isTablet ? 1 : 2) : (isTablet ? 2 : 4)
                }}>
                    <Button
                        type="submit"
                        disabled={isLoading}
                        variant="contained"
                        color="primary"
                        sx={{ textTransform: 'none', width: 140, height: 40 }}
                    >
                        {isLoading && !isPDF ? <CircularProgress color="secondary" size={28} /> :
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('add')}</p>
                                <AddIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        }
                    </Button>
                    <Box sx={{
                        width: isTablet ? 0 : 20,
                        height: isTablet ? 10 : 0
                    }}> </Box>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isLoading}
                        color="primary"
                        sx={{ textTransform: 'none', width: 140, height: 40 }}
                        onClick={() => setPdf(true)}
                    >
                        {isLoading || isPDF ? <CircularProgress color="secondary" size={28} /> :
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('pdf')}</p>
                                <Box width={'6px'}> </Box>
                                <PictureAsPdfOutlinedIcon fontSize="small" />
                            </Box>
                        }
                    </Button>

                    <Box sx={{
                        width: isTablet ? 0 : 20,
                        height: isTablet ? 10 : 0
                    }}> </Box>

                    <Button
                        type="submit"
                        variant="contained"
                        disabled={isLoading}
                        color="primary"
                        sx={{ textTransform: 'none', width: 140, height: 40 }}
                        onClick={() => setPrint(true)}
                    >
                        {isLoading ? <CircularProgress color="secondary" size={28} /> :
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('print')}</p>
                                <Box width={'6px'}> </Box>
                                <LocalPrintshopOutlinedIcon fontSize="small" />
                            </Box>
                        }
                    </Button>

                    <Box sx={{
                        width: isTablet ? 0 : 20,
                        height: isTablet ? 10 : 0
                    }}> </Box>

                    <Button
                        type="button"
                        disabled={isLoading}
                        variant="outlined"
                        color="primary"
                        sx={{ textTransform: 'none', width: 140, height: 40 }}
                        onClick={handleClearForm}
                    >
                        {t('clear')}
                        <Box width={'5px'}> </Box>
                        <CloseOutlinedIcon fontSize="small" />
                    </Button>
                </Box>
            </Box>
        </Box >
    );
}

export default AddPost;